import { render, staticRenderFns } from "./AddressSummary.vue?vue&type=template&id=77216156&scoped=true&"
import script from "./AddressSummary.vue?vue&type=script&lang=ts&"
export * from "./AddressSummary.vue?vue&type=script&lang=ts&"
import style0 from "./AddressSummary.vue?vue&type=style&index=0&id=77216156&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77216156",
  null
  
)

export default component.exports